<template lang="pug">
  v-row
    v-col.text-right(cols="6" xs="12" sm="8" md="8" style="font-size: 0.75rem;")
      span.pagination-text {{ translations.text }}
      v-select.pagination-select(:items="elementsPerPage" @change="$emit('changeLimit', paginationData.offset)" v-model="paginationData.elementsPerPage")
    v-col.text-center(cols="2" style="font-size:0.75rem;")
      span.mr-2 {{pagination.page}}
      span of
      span.ml-2 {{ pagination.totalPages}}
    v-col.text-center(cols="2" md="1" sm="1")
      button(@click="$emit('BackPage')"  :disabled="this.pagination.hasPrevPage == true ? false : true")
        v-icon mdi-chevron-left
    v-col.text-center(cols="2" md="1" sm="1")
      button(@click="nextPage" :disabled="this.pagination.hasNextPage == true ? false : true")
        v-icon mdi-chevron-right

</template>

<script>
  export default {
    name: "pagination",
    props:{
      pagination:{
        type:Object,
        default: function () {
          return{
            hasPrevPage: false,
            hasNextPage: false,
            limit: 30,
            page: 1,
            pageCounter: 1,
            totalPages: 1
          }
        }
      }
    },
    data:() => ({
      elementsPerPage:[
        {
          text: '10',
          value: 10
        },
        {
          text: '20',
          value: 20
        },
        {
          text: '30',
          value: 30
        },
        {
          text: '40',
          value: 40
        },
        {
          text: '50',
          value: 50
        }
      ],
      paginationData:{
        elementsPerPage: 30,
        offset: 0
      }
    }),
    computed: {
      translations(){
        return this.$t("components.pagination");
      },
    },
    created(){
      this.paginationData.offset = this.pagination.limit;
    },
    methods:{
      nextPage(){
        this.pagination.hasNextPage = false;
        this.$emit('NextPage');
      }
    }
  }
</script>

<style lang="sass">
.pagination-text
  transform: translate(-2rem, -1.5rem)
  display: inline-block

.pagination-select
  width: 3rem
  display: inline-block
  font-size: 0.75rem
  transform: translateY(-1.5rem)
</style>